var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssignedWorkers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50.1953,
    height: 50.1953,
    rx: 6,
    fill: "#F7DFD1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1465 33.489C12.9445 33.3493 12.7556 33.1916 12.5822 33.0178C11 31.4369 11 28.8909 11 23.8C11 18.7092 11 16.163 12.5822 14.5822C14.1644 13.0013 16.7092 13 21.8 13H27.2C32.2909 13 34.8369 13 36.4178 14.5822C37.9986 16.1644 38 18.7092 38 23.8C38 28.8909 38 31.4369 36.4178 33.0178C36.2432 33.1933 36.0551 33.3504 35.8535 33.489",
    stroke: "#D87135",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0249 31.7996C18.8585 32.5111 15.798 33.9623 17.6624 35.7781C18.5723 36.665 19.5848 37.2995 20.8619 37.2995H28.137C29.4114 37.2995 30.4253 36.665 31.3365 35.7781C33.1995 33.9623 30.1391 32.5111 28.9727 31.7996C27.6238 30.9815 26.0764 30.5488 24.4988 30.5488C22.9212 30.5488 21.3738 30.9815 20.0249 31.7996Z",
    stroke: "#D87135",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.875 23.8008C27.875 24.6959 27.5194 25.5543 26.8865 26.1873C26.2536 26.8202 25.3951 27.1758 24.5 27.1758C23.6049 27.1758 22.7464 26.8202 22.1135 26.1873C21.4806 25.5543 21.125 24.6959 21.125 23.8008C21.125 22.9057 21.4806 22.0472 22.1135 21.4143C22.7464 20.7814 23.6049 20.4258 24.5 20.4258C25.3951 20.4258 26.2536 20.7814 26.8865 21.4143C27.5194 22.0472 27.875 22.9057 27.875 23.8008Z",
    stroke: "#D87135",
    strokeWidth: 1.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignedWorkers);
export default __webpack_public_path__ + "static/media/assigned-workers.636dcfbb339974c6e7420993b561308e.svg";
export { ForwardRef as ReactComponent };